"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = void 0;
var CrudService_1 = __importDefault(require("../Core/CrudService"));
var entityName = 'optimization_result';
var prefix = 'own-fleet-optimization-service';
exports.Routes = {
    GET: "/".concat(prefix, "/optimization_result"),
    GET_ALL: "/".concat(prefix, "/optimization_results"),
    RERUN: "/".concat(prefix, "/route_optimization/rerun_optimization")
};
var OptimizationResultService = /** @class */ (function () {
    function OptimizationResultService(session) {
        this.service = new CrudService_1.default(session, entityName, prefix);
    }
    OptimizationResultService.prototype.load = function (teamId, requestUuid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .get(exports.Routes.GET)
                            .setException('failed to load optimization result')
                            .withQueryString({ team_id: teamId, request_uuid: requestUuid })
                            .invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    OptimizationResultService.prototype.loadAll = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .get(exports.Routes.GET_ALL)
                            .setException('failed to load optimization results')
                            .withQueryString({
                            team_id: request.team_id,
                            start_time: request.start_time,
                            end_time: request.end_time,
                            page_size: request.page_size,
                            page_number: request.page_number,
                            origin: request.origin,
                            user_ids: request.user_ids,
                            sort_column: request.sort_column,
                            sort_direction: request.sort_direction,
                            request_uuids: request.request_uuids,
                            parent_request_uuids: request.parent_request_uuids,
                            optimization_solver: request.optimization_solver
                        })
                            .invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    OptimizationResultService.prototype.rerun = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .post(exports.Routes.RERUN)
                            .setException("failed to rerun optimization, request_uuid:".concat(request.request_uuid, ", parent_request_uuid:").concat(request.parent_request_uuid))
                            .withPayload({
                            parent_request_uuid: request.parent_request_uuid,
                            request_uuid: request.request_uuid,
                            configuration: request.configuration,
                            resources: request.resources
                        })
                            .invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return OptimizationResultService;
}());
exports.default = OptimizationResultService;
//# sourceMappingURL=optimization-result-service.js.map